import * as React from 'react';
import classNames from 'classnames';
import {CircleWarningIcon} from '@discordapp/design/components/Icon/generated/CircleWarningIcon.web';

import Button from '@developers/uikit/Button';
import {ComponentDispatch} from '@developers/utils/ComponentDispatchUtils';

import {ComponentActions} from '@developers/Constants';
import {Messages} from '@developers/i18n';
import styles from './UnsavedChangesNotice.module.css';

export enum UnsavedChangesNoticeSaveType {
  SAVE,
  PUBLISH,
}

export interface UnsavedChangesNoticeProps {
  saving: boolean;
  saveDisabled?: boolean;
  saveType?: UnsavedChangesNoticeSaveType;
  className?: string;
  noticeRef?: React.Ref<HTMLDivElement>;
  onReset: () => void;
  onSave: () => void;
}

export default function UnsavedChangesNotice({
  saving,
  saveDisabled,
  saveType = UnsavedChangesNoticeSaveType.SAVE,
  className,
  onReset,
  onSave,
  noticeRef,
}: UnsavedChangesNoticeProps) {
  const [emphasized, setEmphasized] = React.useState(false);

  React.useEffect(() => {
    const emphasize = () => {
      setEmphasized(true);
      setTimeout(() => setEmphasized(false), 1000);
    };
    ComponentDispatch.subscribe(ComponentActions.EMPHASIZE_NOTICE, emphasize);
    return () => {
      ComponentDispatch.unsubscribe(ComponentActions.EMPHASIZE_NOTICE, emphasize);
    };
  }, []);

  let actionMessage;
  switch (saveType) {
    case UnsavedChangesNoticeSaveType.SAVE:
      actionMessage = Messages.ACTIONS_SAVE_CHANGES;
      break;
    case UnsavedChangesNoticeSaveType.PUBLISH:
      actionMessage = Messages.ACTIONS_PUBLISH_CHANGES;
      break;
  }

  return (
    <div ref={noticeRef} className={classNames(styles.container, emphasized ? styles.emphasized : null, className)}>
      <div className={styles.contentWrap}>
        <div className={styles.messageWrap}>
          <div className={styles.message}>
            <CircleWarningIcon size="md" color="var(--yellow-260)" />
            {Messages.COMMON_SETTINGS_NOTICE_MESSAGE}
          </div>
        </div>
        <div className={styles.buttonWrap}>
          {onReset != null && (
            <Button
              className={styles.resetButton}
              height={Button.Height.SHORT}
              color={Button.Color.PRIMARY}
              look={Button.Look.LINK}
              onClick={onReset}>
              <span>{Messages.ACTIONS_RESET}</span>
            </Button>
          )}
          <Button
            disabled={saveDisabled}
            className={styles.button}
            color={Button.Color.GREEN}
            submitting={saving}
            onClick={onSave}>
            {actionMessage}
          </Button>
        </div>
      </div>
    </div>
  );
}
